module.exports = __webpack_public_path__ + "img/mysalon-sm.00b6581e.svg";